import { StorageUtils, storageUtils } from "@/core/utils/utils";

export const useStorage = (): StorageUtils => {
  return storageUtils;
};
